module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('h2', {
    staticClass: "fm_titlea"
  }, [_vm._v("Editor’s Foreword")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Yearbook of Astronomy 2019 is the latest edition of what has long been an indispensable publication, the annual appearance of which has been eagerly anticipated by astronomers, both amateur and professional, for well over half a century. As ever, the Yearbook is aimed at both the armchair astronomer and the active backyard observer. Within its pages you will find a rich blend of information, star charts and guides to the night sky coupled with an interesting mixture of articles which collectively embrace a wide range of topics, ranging from the history of astronomy to the latest results of astronomical research; space exploration to observational astronomy; and our own celestial neighbourhood out to the farthest reaches of space.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monthly Star Charts")]), _vm._v(" have been compiled by David Harper and show the night sky as seen throughout the year. Two sets of twelve charts have been provided, one set for observers in the Northern Hemisphere and one for those in the Southern Hemisphere. Between them, each pair of charts depicts the entire sky as two semi-circular half-sky views, one looking north and the other looking south.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("In response to helpful feedback from readers of the 2018 edition, two new items have been added to the first section of the Yearbook. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Planets in 2019")]), _vm._v(" gives a concise summary of the observing conditions for each of the planets during the year and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Some Events in 2019")]), _vm._v(" is a calendar of significant ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-82",
      "id": "gloss_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solar")]), _vm._v(" System events occurring throughout 2019. Lists of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Phases of the Moon in 2019")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eclipses in 2019")]), _vm._v(" are also provided. Further improvements and additions are planned for the 2020 edition of the Yearbook, including visibility diagrams for Mercury and Venus and finder charts for the outer planets. In the meantime, suggestions from readers are welcomed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monthly Sky Notes")]), _vm._v(" have been compiled by Lynne Marie Stockman and give details of the positions and visibility of the planets throughout 2019. The sky notes now contain additional information to that provided in the 2018 edition, which it is hoped will enhance their usefulness to observers. Each "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("section of the Monthly Sky Notes is accompanied by a short article, the range of which includes not only observing guides to specific ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-22",
      "id": "gloss_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("constellations")]), _vm._v(" on view at the time but also items on a wide variety of astronomy-related topics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Monthly Sky Notes and Articles section of the book rounds off with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Comets in 2019")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Minor Planets in 2019")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Meteor Showers in 2019")]), _vm._v(", all three written and provided by Neil Norman and all three titles being fairly self-explanatory, describing as they do the occurrence and visibility of examples of these three classes of object during and throughout the year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Astronomy in 2018")]), _vm._v(" Rod Hine covers a range of topics, including a summary of the continuing interest in the TRAPPIST-1 star system and a close look at the ongoing mysteries of Dark Matter and Dark Energy and the latest attempts by scientists to explain them. This is followed by "), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-84",
      "id": "gloss_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solar System")]), _vm._v(" Exploration in 2018")]), _vm._v(" in which Peter Rea provides information on a wide range of space missions, including the eagerly anticipated BepiColombo mission to Mercury and the exciting "), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-8",
      "id": "gloss_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("asteroid")]), _vm._v(" sample return mission OSIRIS-Rex. Launched in September 2016 to study the carbon-rich asteroid 101955 Bennu, the objectives of OSIRIS-Rex include orbiting and mapping the asteroid prior to touching down on the surface to collect, and subsequently return, a small sample to Earth for analysis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 2019 we celebrate the 400th anniversary of the birth of Jeremiah Horrocks whose achievements during his short life suggest that he had the potential to be one of the greatest of astronomers. In his article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anniversaries in 2019")]), _vm._v(" Neil Haggath explores the short-lived but brilliant career of Jeremiah Horrocks, who was born in 1619 and whose life was tragically cut short by his death in 1641 at the age of just 22 years. Among the other anniversaries covered in Neil’s article is what is perhaps the most obvious one of all, that of the 50"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" anniversary of the first landing of humans on the Moon, this by the Apollo 11 mission in 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Cassini-Huygens Mission to the Saturn System")]), _vm._v(" Carl Murray provides us with a detailed overview of the magnificent achievements of this historic mission. Carl has been directly involved with the Cassini project since the 1990s, and his article presents us with an interesting and informative summary of what can only be described as a highly successful mission.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is followed by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Science Fiction and the Future of Astronomy")]), _vm._v(" by Mike Brotherton, who informs us that one of the primary jobs of science fiction is to try to forecast the future in an entertaining and perhaps adventurous way. Although "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("not always successful, science fiction has tended to hit the mark reasonably often in a number of areas, including technology, forecasting the development of space travel, robots and ever smaller and more powerful computers. In this fascinating article, Mike looks to the future, and the opportunities astronomers may be presented with through the ongoing evolution of the telescopes and other instrumentation they use to explore the Universe.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Well known for his discovery of Phobos and Deimos, the two moons of Mars, in August 1877, the famous American astronomer Asaph Hall is the subject of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Asaph Hall: Man of Mars")]), _vm._v(" by Neil Norman. The article provides us not only with the story of the discoveries of Phobos and Deimos, but also a great deal about the life and other achievements of Asaph Hall.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Following his article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Double and Multiple Stars")]), _vm._v(" in the 2018 edition of the Yearbook, John McCue has now taken this a stage further. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Getting the Measure of ")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-27",
      "id": "gloss_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double Stars")]), _vm._v(", John points out that the observation of double stars can be a rewarding pursuit, even in these days of light polluted skies. He then goes on to inform us of the different methods and techniques that can be used to observe and measure "), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-13",
      "id": "gloss_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("binary stars")]), _vm._v(". The steady accumulation over time of these observations and measurements provides valuable information, which eventually allows the "), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-63",
      "id": "gloss_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("orbits")]), _vm._v(" of binary star components around each other to be refined and calculated. As the article clearly demonstrates, binary star observation is one of the areas of observation to which the backyard astronomer can make useful contributions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two important centenaries are then highlighted, the first of which is that of the founding of the "), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-41",
      "id": "gloss_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("International Astronomical Union (IAU)")]), _vm._v(", described in Susan Stubbs’ informative article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("100 Years of the International Astronomical Union")]), _vm._v(" which, as well as covering the early years of the IAU, goes on to tell us a great deal about the role of the IAU in modern day astronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is followed by Neil Haggath’s article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In Total Support of Einstein: Eddington’s "), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-28",
      "id": "gloss_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eclipse")]), _vm._v(", 1919")]), _vm._v(" in which he describes Sir Arthur Eddington’s expedition to Príncipe off the west coast of Africa to witness the "), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-83",
      "id": "gloss_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("solar eclipse")]), _vm._v(" of 29 May 1919, the results of which were used to verify the bending of light by the Sun’s gravity, as predicted by Einstein’s General Theory of Relativity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The First Micro-Quasar")]), _vm._v(" regular contributor David Harland tells the fascinating story behind the momentous discovery of a micro-quasar "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("which, at the time it was first brought to light in 1978-1980, represented an entirely new class of astronomical object.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("This is followed by our penultimate article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Father Lucian Kemble and the Kemble ")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-7",
      "id": "gloss_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asterisms")]), _vm._v(" in which Steve Brown examines the life and achievements of Franciscan Friar and amateur astronomer Lucian Kemble, who first came to the attention of many through his discovery of the three attractive asterisms that now bear his name – Kemble 2, Kemble’s Kite and the famous Kemble’s Cascade, each of which is examined in detail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The constellation of Cetus (the Whale) plays host to Mira, one of the best known variable stars in the entire sky. In our final article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mira ‘The Wonderful’")]), _vm._v(" Roger Pickard explores not only the early history of observation of Mira, but also what subsequent and current research has told us about this famous star, and other objects of its type.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The final section of the book starts off with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Some Interesting Variable Stars to Observe in 2019")]), _vm._v(" by Roger Pickard which contains useful information on variables, including the well known long-period variable star Mira, as well as predictions for timings of minimum brightness of the famous eclipsing binary Algol for 2019. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Some Interesting Double Stars")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Some Interesting Nebulae, "), _c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary#gloss-91",
      "id": "gloss_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Star Clusters")]), _vm._v(" and Galaxies")]), _vm._v(" present a selection of objects for you to seek out in the night sky. The lists included here are by no means definitive and may well omit your favourite celestial targets. If this is the case, please let us know and we will endeavour to include these in future editions of the Yearbook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The book rounds off with a selection of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Astronomical Organizations")]), _vm._v(", which lists organizations and associations across the world through which you can further pursue your interest and participation in astronomy (if there are any that we have omitted please let us know) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Our Contributors")]), _vm._v(", which contains brief background details of the numerous writers who have contributed to the Yearbook of Astronomy 2019. Finally, following the introduction of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glossary")]), _vm._v(" to the Yearbook of Astronomy in the 2018 edition, this has been expanded for 2019 with the addition of many new entries of brief but informative explanations for many of the words, and much of the terminology, used in the Yearbook (as well as a few more).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over time new topics and themes will be introduced into the Yearbook to allow it to keep pace with the increasing range of skills, techniques and observing methods now open to amateur astronomers, this in addition to "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("articles relating to our rapidly-expanding knowledge of the Universe in which we live. There will be an interesting mix, some articles written at a level which will appeal to the casual reader and some of what may be loosely described as at a more academic level. The intention is to fully maintain and continually increase the usefulness and relevance of the Yearbook of Astronomy to the interests of the readership who are, without doubt, the most important aspect of the Yearbook and the reason it exists in the first place.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As ever, grateful thanks are extended to those individuals who have contributed a great deal of time and effort to the Yearbook of Astronomy 2019, not least of which is David Harper, who has provided updated versions of his excellent Monthly Star Charts. These were generated specifically for what has been described as the new generation of the Yearbook of Astronomy, and the charts add greatly to the overall value of the book to star gazers. Equally important are the efforts of Lynne Marie Stockman who has put together the Monthly Sky Notes. Their combined efforts have produced what can justifiably be described as the backbone of the Yearbook of Astronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also worthy of mention is Garry (Garfield) Blackmore who, as well as preparing many of the illustrations for publication, has produced the artwork for the smaller star charts included with a number of the articles. Thanks also go to Jonathan Wright, Lori Jones, Kate Bamforth, Janet Brookes and Paul Wilkinson of Pen & Sword Books Ltd without whose combined help, belief and confidence in the Yearbook of Astronomy, this much-loved and iconic publication may well have disappeared for ever.")]), _vm._v(" "), _c('p', {
    staticClass: "rightt"
  }, [_vm._v("Brian Jones – Editor")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Bradford, West Riding of Yorkshire")]), _vm._v(" "), _c('p', {
    staticClass: "rightt"
  }, [_vm._v("February 2018")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("As many of you will be aware, the future of the Yearbook of Astronomy was under threat following the decision to make the 2016 edition the last. However, the series was rescued, both through the publication of a special 2017 edition (which successfully maintained the continuity of the Yearbook) and a successful search for a publisher to take this iconic publication on and to carry it to even greater heights as the Yearbook approaches its diamond jubilee in 2022.")])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("The Yearbook of Astronomy 2017 was a limited edition, although copies are still available to purchase. It should be borne in mind that you would not be obtaining the 2017 edition as a current guide to the night sky, but as the landmark edition of the Yearbook of Astronomy which fulfilled its purpose of keeping the series alive, and which heralded in the new generation of this highly valued and treasured publication. You can order your copy of the 2017 edition at "), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "weblink"
  })])]), _c('a', {
    attrs: {
      "href": "http://www.starlight-nights.co.uk/subscriber-2017-yearbook-astronomy",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.starlight-nights.co.uk/subscriber-2017-yearbook-astronomy")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dc139aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Editors.vue
// module id = 72
// module chunks = 0